import { INITIALIZE_SOCKET,WITHOUT_INIT_SOCKET,GET_SOCKET_CONNECTION_STATUS } from "../constants";

const initialState = {
    initializeSocket: false,
    withoutInitSocket:false,
    socketConnectionStatus: false
};

const socketReducer = (state = initialState, action = null) => {
    switch (action.type) {
        case INITIALIZE_SOCKET:
            return {
                ...state,
                initializeSocket: action.payload,
            };
            case GET_SOCKET_CONNECTION_STATUS:
            return {
                ...state,
                socketConnectionStatus: action.payload,
            }
            case WITHOUT_INIT_SOCKET:
            return {
                ...state,
                withoutInitSocket: action.payload,
            };
        default:
            return state;
    }
};

export default socketReducer;
